import { ArrayParam, BooleanParam,NumberParam, useQueryParams, withDefault } from 'use-query-params';

const useGetSearchParameters = ({ allFields }) => {
  const fieldParams = {};
  const getType =(s)=>allFields.filter(({ slug })=>slug===s)?.[0]?.type;
  for (const { type, slug } of allFields) {
    if (type === 'bool') {
      fieldParams[slug] = withDefault(BooleanParam, null);
    } else if (type === 'int' || type === 'float') {
      fieldParams[`${slug}_min`] = withDefault(NumberParam, null);
      fieldParams[`${slug}_max`] = withDefault(NumberParam, null);
    } else if (type === 'name' || type === 'stars' || type === 'term' || type === 'names') {
      fieldParams[slug] = withDefault(ArrayParam, []);
    } else {
      console.warn({ error: 'Field type not defined', type, slug });
      throw 'Invalid Field Configuration';
    }
  }
  const [searchParams, setSearchParams] = useQueryParams(fieldParams);
  const getActiveParams = ()=>{
    let count=0;
    const seen = new Set();
    for (const { type, slug } of allFields) {

      if (seen.has(slug)){
        continue;
      }
      seen.add(slug);

      if (type === 'bool') {
        if (searchParams[slug]===true){
          count+=1;
        }
      } else if (type === 'int' || type === 'float') {
        if         (searchParams[`${slug}_min`]!==null||searchParams[`${slug}_max`]!==null){
          count+=1;
        }
      } else if (type === 'name' || type === 'stars' || type === 'term' || type === 'names') {
        if (searchParams[slug]?.length>0) {
          count += 1;
        }
      }
    }

    return count;
  };
  return {
    searchParams,
    setSearchParams: newParams=>{
      const allNewParams = Array.isArray(newParams)?newParams:[newParams];
      const newSp={ ...searchParams };
      for (const { slug, newValue } of allNewParams){
        const t = getType(slug);
        if (t==='int' || t==='float'){
          newSp[`${slug}_min`]=newValue[0];
          newSp[`${slug}_max`]=newValue[1];
        }else{
          newSp[slug]=newValue;
        }
        newSp['page']=null;
      }
      setSearchParams(newSp);
    },
    activeParams:getActiveParams(),
    clearParams:()=>{
      const newParams={};
      for (const { type, slug } of allFields) {
        if (type === 'bool') {
          newParams[slug]=null;
        } else if (type === 'int' || type === 'float') {
          newParams[`${slug}_min`]=null;
          newParams[`${slug}_max`]=null;
        } else if (type === 'name' || type === 'stars' || type === 'term' || type === 'names') {
          newParams[slug]=[];
        }
      }
      setSearchParams(newParams);
    },
  };


};

export { useGetSearchParameters };
export default useGetSearchParameters;
